import { useState } from 'react'

import { EMPTY_FUNCTION } from '../../../../../constants/common'

import { runAfterPaint } from './useUploadImageModalSubmit.utils'

// Two-step save under one `isSubmitting`: upload the cropped image to the
// document endpoint, then `onSave` persists the id onto the entity (it MUST
// return a Promise — the modal closes only when it resolves).
export function useUploadImageModalSubmit({
  documentType,
  engine,
  parent,
  onClose,
  onSave,
  onUpload,
}) {
  const [isSubmitting, setSubmitting] = useState(false)
  const [isUploadFailed, setUploadFailed] = useState(false)

  function handleSubmit() {
    setSubmitting(true)
    setUploadFailed(false)

    // `getCroppedImage` blocks the main thread for seconds on large images —
    // defer past a paint so the loading state shows first.
    runAfterPaint(() => {
      engine
        .getCroppedImage()
        .then(result =>
          onUpload({
            dataUrl: result.dataUrl,
            name: engine.fileName,
            parent,
            type: documentType,
          }).then(
            document =>
              onSave({ document, documentId: document?.id, ...result }).then(
                () => onClose()
              ),
            // A step-1 failure is the modal's own error state (retry via Reload).
            () => setUploadFailed(true)
          )
        )
        // Step-2 failures are surfaced by the caller; swallowed here only so
        // they don't become unhandled rejections (the modal stays open).
        .catch(EMPTY_FUNCTION)
        .finally(() => setSubmitting(false))
    })
  }

  return { handleSubmit, isSubmitting, isUploadFailed, setUploadFailed }
}
